import Image from 'next/image';
import Link from 'next/link';
import React, { useEffect, useRef, useState } from 'react';

export default function allvodbox(props) {
  /**
   *  
   * 1."text_color":"b",   의 의미 ??  타입 대신 쓰임
   * 2. 링크주소 정리 
   * 3. talk 서비스 주소 정의
   * 
   */
  useEffect(() => {
    //alert('www');
    window.__SBSLogModuleDataLayer = window.__SBSLogModuleDataLayer || [];
  }, []);

  const handleClick_custom = (a,b,c,d) => {
    window.__SBSLogModuleDataLayer.push({
      type: 'click',
      option: {
        clickName: 'AllVOD최상단타이틀',
        clickType: 'NC',
        value1: '',
        value2: '',
        value3: '',
        value4: '',
        value5: ''
      }
    });

  };

  const handleClick = (a,b,c,d,e,f,g,h) => {

    let moduleSubTitle;
    let contentId;
    let content_type;
    let allvod_id;
    let allvod_title;
    let allvod_sub_title;
    let tmp_cid;
    let tmp_title;
    if (f == 'link') {
      content_type = 'LK';
    } else if (f == 'watch') {
      content_type = 'C';
    } else {
      content_type = 'LS';
    }
    if (d === '10338') {
      allvod_id = 'AllVOD'
      allvod_title = 'AllVOD_홍보타입'
      tmp_title  = 'AllVOD_홍보타입'
      allvod_sub_title =props.data.subtitle1;
      tmp_cid = b.title;
      moduleSubTitle = '홍보타입';
      if (f == 'link') {
        contentId = 'link';
      } else if (f == 'watch') {
        contentId = h;
      } else {
        contentId = 'theme';
      }
    } else if (d === '11681') {
      tmp_cid = b.title;
      allvod_id = 'AllVOD'
      allvod_title = 'AllVOD_테마타입'
      tmp_title  = 'AllVOD_테마타입'
      allvod_sub_title =props.data.subtitle2;
      contentId = b.uniq_no;
      moduleSubTitle = 'theme';
    } else {

      allvod_id = 'AllVOD'
      allvod_title = 'AllVOD_패키지할인'
      allvod_sub_title =props.data.subtitle3;
      tmp_title = b.combi_id
      // contentId = b.combi_id

      d = contentId;
      e = b.title;
      tmp_cid = contentId;
      moduleSubTitle = props.data.combi_id;
    }


    //통계에 넙겨줄 값을정리한다,상단여역 pgmbox 프로그램 / 메뉴 / 플레이톡이 있음
    window.__SBSLogModuleDataLayer.push({
      type: 'content',
      option: {
        moduleId: allvod_id, //모듈 아이디 없으면
        moduleTitle: allvod_title,
        moduleSubTitle: allvod_sub_title,
        moduleActive: 'C', //콘텐츠 선택 정보 Click: C, Hover: H
        moduleSeq: props.loc_idx, //페이지에서 해당 모듈의 위치
        moduleItemSeq: c, //모듈 내에서 콘텐츠의 위치
        programId: g, //프로그램의 아이디 (추가)
        programTitle: '', //프로그램의 제목 (추가)
        contentId: tmp_title, //식별자
        contentTitle: b.title, //콘텐츠의 제목  (Require)
        contentNumber: '',
        contentType: content_type,
      },
    });
  };

  return (
    <>
      {/* <!-- 다크그레이 배경 -->*/}
      <div className="mainContents-typeDarkgray" >
        {/* <!-- allvod 타이틀 배너 -->*/}
        <div div className="contentsBlock_w allvodBanner_w" >
          <a  onClick={(e) => handleClick_custom(e, '','0','all')}  href={props.data.alllink_url} className="allvodBnrLink">
            <strong className="iconSvg_allvod"><i className="hide">AllVOD</i></strong>
            <div className="allvodBnrTitle">
              <span className="allvodBnr-title">무료로 ZERO PLAY!</span>
              <span className="allvodBnr-arrow"><i className="iconSvg_arrow"></i></span>
            </div>
          </a>
          <i className="allvodBg-topLeft"><img src="/images/m/ct_play.png" alt="" /></i>
          <i className="allvodBg-topRight"><img src="/images/m/ct_pause.png" alt="" /></i>
        </div>





        {/* <!-- 테마형 큐레이션 영역 -->*/}
        <div div className="contentsBlock_w curationType1" >
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.subtitle1}</h2>
            <a href={props.data.contents1.alllink_url} className="moduleTitleline-linkMore" style={{ visibility: (props.data.contents1.alllink_yn == 'Y' && props.data.contents1.alllink_url != '' && props.data.contents1.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.contents1.alllink_title}</a>
          </div>
          <div className={"listModule_w_allvodCurationType1 allvodCurationType1" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">

                {
                  props.data.contents1.map((item, index) => {
                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_clip">
                          <Link href={item.link_url} >
                            <a  onClick={(e) => handleClick(e, item,index,'10338',props.data.subtitle1,item.type,item.pgm_id,item.mda_id)} target={item.link_new_yn == 'Y' ? '_blank' : ''} className="mb_link">
                              <div className="mb_image_w">
                                <div className="mb_image_inner">
                                  <img src={item.img_url} className="mb_image" alt={item.img_attr} />
                                </div>
                              </div>
                              <div className="mb_info_w">
                                <span className="mbif_title">{item.title}</span>
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        {/* <!-- 테마형 큐레이션 영역 -->*/}
        <div div className="contentsBlock_w curationType2" >
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.subtitle2}</h2>
            <a href={props.data.contents2.alllink_url} className="moduleTitleline-linkMore" style={{ visibility: (props.data.contents1.alllink_yn == 'Y' && props.data.contents1.alllink_url != '' && props.data.contents1.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.contents1.alllink_title}</a>
          </div>
          <div className={"listModule_w_allvodCurationType2 allvodCurationType2" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">{/* <!-- mySwiper 클래스 추가시 동작 -->*/}
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  props.data.contents2.map((item, index) => {
                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_theme">
                          <Link href={item.link_url} >
                            <a  onClick={(e) => handleClick(e, item,index,'11681',props.data.subtitle2,'','','')} target={item.link_new_yn == 'Y' ? '_blank' : ''} className="mb_link">
                              <div className="mb_image_w">
                                <div className="mb_image_inner">
                                  <img src={item.img_url} className="mb_image" alt={item.attr} />
                                </div>
                              </div>
                              <div className="mb_info_w">
                                <span className="mbif_title">{item.title}</span>
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
        {/* <!-- 테마형 큐레이션 영역 -->*/}
        <div div className="contentsBlock_w curationType3" >
          <div className="moduleTitleline_w">
            <h2 className="moduleTitleline-Title">{props.data.subtitle3}</h2>
            <a href={props.data.contents2.alllink_url} className="moduleTitleline-linkMore" style={{ visibility: (props.data.contents1.alllink_yn == 'Y' && props.data.contents1.alllink_url != '' && props.data.contents1.alllink_url != null) ? 'visible' : 'hidden' }}>{props.data.contents1.alllink_title}</a>
          </div>
          <div className={"listModule_w_allvodCurationType3 allvodCurationType3" + props.loc_idx}>
            <div className="listModuleSlider listScrollSlider">
              {/* <!-- 리스트 -->*/}
              <div className="SliderContent swiper-wrapper">
                {
                  props.data.contents3.map((item, index) => {
                    return (
                      <div className="listModuleItem swiper-slide">
                        <div className="moduleBoxWrap_package">
                          <Link href={item.link_url} >
                            <a  onClick={(e) => handleClick(e, item,index,'paks','','','','')}  target={item.link_new_yn == 'Y' ? '_blank' : ''} className="mb_link">
                              <div className="mb_image_w">
                                <div className="mb_image_inner">
                                  <img src={item.img_url} className="mb_image" alt={item.attr} />
                                </div>
                                <div className="label_package_w">
                                  <div className="package_number_w">
                                    <em className="package_number">{item.sale_per}</em>
                                    <span className="iconSvg_percent"><i className="hide">%</i></span>
                                  </div>
                                  <span className="iconSvg_packageText"><i className="hide">할인</i></span>
                                </div>
                              </div>
                              <div className="mb_info_w">
                                <span className="mbif_title">{item.title}</span>
                              </div>
                            </a>
                          </Link>
                        </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
          </div>
        </div>
      </div >
    </>
  );

}